import { Api } from '@cui/req';
import axios from 'axios';
import { PostFile } from './type';
import { message } from 'antd';
import { ProcessParams, ProcessVariables } from '@/types/process';

const baseUrl = '/api';

// 查询审批流程（只查询到当前审批到的节点，不是所有节点）
export const queryProcessData = async ({ taskId, dataId, version }: { taskId: string; dataId: string; version: string }) => {
  const [err, res] = await Api({
    url: `${baseUrl}/gateway/process_platform/process/query/${taskId}/${dataId}/${version}`,
    method: 'get',
  });
  return res?.data || [];
};

// 完成审批节点
export const queryProcessComplete = async (data: any) => {
  const [err, res] = await Api({
    url: `${baseUrl}/gateway/process_platform/process/complete`,
    method: 'post',
    data,
  });
  return res;
};

export const uploadFile: PostFile = async ({
  namespaceID,
  moduleID,
  upload,
}: any) => {
  try {
    const resData = await axios.post(
      `${baseUrl}/cutler/compose/namespace/${namespaceID}/module/${moduleID}/record/attachment`,
      upload,
    );
    return resData?.data?.response;
  } catch (err) {
    message.error('附件上传失败');
    return {};
  }
};

export async function postRecordList({
  pageNum = 1,
  pageSize = 1000,
  app_id = 'tech',
  model_id = 'flow_node',
  ...others }: any): Promise<any> {
  const keys = Object.keys(others).filter((key: string) => key);
  const str = keys.map((key: string) => `${key} = \${${key}} `).join(' AND ');
  const [err, res] = await Api({
    method: 'post',
    url: `${baseUrl}/gateway/metabase/api/v1/${app_id}/${model_id}/page`,
    data: {
      condition: keys.length > 0 ? str : '',
      pageNum,
      pageSize,
      parameters: others,
    },
  });
  return res?.data || {};
}


// 查询审批历史
export const queryAllProcessData = async ({ taskId, dataId, version }: { taskId: string; dataId: string; version: string }) => {
  const [err, res] = await Api({
    url: `${baseUrl}/gateway/process_platform/process/query/history/${taskId}/${dataId}/${version}`,
    method: 'get',
  });
  return res?.data || [];
};

// 基础数据模型对应recordList通用请求接口
export const getBaseRecordList = async ({
  modelId,
  data,
  appId,
}: any) => {
  const [err, res] = await Api({
    url: `/api/gateway/metabase/api/v1/${appId}/${modelId}/page`,
    method: 'POST',
    data,
  });
  return res?.data;
};

/**
 * 查询流程实例的一些变量
 * @param params
 * @returns
 */
export const queryProcessVariables = async (params: ProcessParams): Promise<ProcessVariables> => {
  const { taskId, dataId, version } = params;
  const [err, res] = await Api({
    url: `${baseUrl}/gateway/process_platform/process/query/variables/${taskId}/${dataId}/${version}`,
    method: 'get',
  });
  return res?.data || [];
};
